// import React from 'react';
// import { Divider,Form,Input,Button} from 'antd';

// const App = () => { 
//     return(
        
//     <Form name = "basic" layout="vertical">
//         <Form.Item
//         label = "文章标题"
//         name  = "title"
//         rules = {[{ required: true, message: '请输入文章标题' },]}
//         >
//             <Input placeholder="请输入文章标题" />
//         </Form.Item>

//         <Form.Item
//         label = "文章摘要"
//         name  = "abstract"
//         rules = {[{ required: true, message: '请输入文章摘要' },]}
//         >
//             <Input.TextArea placeholder="请输入文章摘要,不超过200字" rows={4} />
//         </Form.Item>
//         <Form.Item
//         label = "标签"
//         name  = "labels"
//         rules = {[{ required: true, message: '请输入标签' },]}
//         >
//             <Input.TextArea placeholder="选择或输入标签(按回车键创建新标签)" rows={4} />
//         </Form.Item>
//         <Form.Item
//         label = "文章内容(支持Markdown语法)"
//         name  = "content"
//         rules = {[{ required: true, message: '请输入文章内容' },]}
//         >
//             <Input.TextArea placeholder="请使用Markdown 格式输入文章内容" rows={4} />
//         </Form.Item>
//         <Form.Item>
//             <Button type="primary" htmlType="submit">
//                 提交
//             </Button>
//         </Form.Item>
//     </Form>
//     );
// };


// src/pages/WritePost/index.js
import React, { useState } from 'react';
import { 
  Form, 
  Input, 
  Button, 
  DatePicker, 
  Select, 
  Card, 
  Typography, 
  message 
} from 'antd';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const WritePost = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 模拟API调用
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const newPost = {
        id: Date.now(),
        title: values.title,
        content: values.content,
        summary: values.summary,
        date: moment(values.date).format('YYYY-MM-DD'),
        tags: values.tags,
      };
      
      console.log('新文章:', newPost);
      message.success('文章发布成功！');
      form.resetFields();
      navigate('/archive');
    } catch (error) {
      message.error('发布失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const tagOptions = [
    '大二', '校园', '美食', '武汉', '攻略', 
    '技术', '生活', '旅行', '学习', '随笔'
  ];

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <Card>
        <Title level={2} style={{ marginBottom: 24 }}>写文章</Title>
        
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            date: moment(),
            tags: []
          }}
        >
          <Form.Item
            name="title"
            label="标题"
            rules={[{ required: true, message: '请输入文章标题' }]}
          >
            <Input placeholder="请输入文章标题" size="large" />
          </Form.Item>

          <Form.Item
            name="date"
            label="发布日期"
            rules={[{ required: true, message: '请选择发布日期' }]}
          >
            <DatePicker style={{ width: '100%' }} size="large" />
          </Form.Item>

          <Form.Item
            name="tags"
            label="标签"
            rules={[{ required: true, message: '请选择标签' }]}
          >
            <Select
              mode="tags"
              placeholder="选择或输入标签"
              size="large"
              style={{ width: '100%' }}
            >
              {tagOptions.map(tag => (
                <Option key={tag} value={tag}>{tag}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="summary"
            label="摘要"
            rules={[{ required: true, message: '请输入文章摘要' }]}
          >
            <TextArea
              rows={3}
              placeholder="请输入文章摘要"
              maxLength={200}
              showCount
            />
          </Form.Item>

          <Form.Item
            name="content"
            label="内容"
            rules={[{ required: true, message: '请输入文章内容' }]}
          >
            <TextArea
              rows={12}
              placeholder="请输入文章内容（支持Markdown格式）"
              showCount
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              size="large"
              loading={loading}
              style={{ width: 120 }}
            >
              发布
            </Button>
            <Button 
              style={{ marginLeft: 16 }}
              onClick={() => form.resetFields()}
              size="large"
            >
              重置
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default WritePost;